// ----------------------------------------------------------------------

export default function Toolbar(theme) {
  const isLight = theme.palette.mode === 'light';

  return {
    MuiToolbar: {
      styleOverrides: {},
    },
  };
}
